import React from "react";

const Badge = ({ children, color }) => (
  <span className={`p-1 rounded-md ${color}`}>{children}</span>
);

export default Badge;
